(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('toggleImages');
    if (!btn) return;

    btn.addEventListener('click', function () {
      const extraImages = document.querySelectorAll('.extra-image');
      const expanded = btn.getAttribute('data-expanded') === 'true';

      if (!expanded) {
        extraImages.forEach(function (el) {
          el.style.display = 'block';
        });

        btn.textContent = 'Collapse All Images';
        btn.setAttribute('data-expanded', 'true');
      } else {
        extraImages.forEach(function (el) {
          el.style.display = 'none';
        });

        btn.textContent = 'Show More Images';
        btn.setAttribute('data-expanded', 'false');

        document.getElementById('ProductPhotos-{{ section_id }}').scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  });

  // front-end-hydration-builder Start
  (function() {
    const initVariantSync = () => {
      const thumbContainer = document.querySelector('.product__thumbs');
      if (!thumbContainer) return;

      const syncVariant = (activeElement) => {
        const img = activeElement.querySelector('img');
        const altText = img ? img.alt.trim() : null;

        if (altText) {
          const dropdowns = document.querySelectorAll('.variant-input-wrap select');
          dropdowns.forEach(select => {
            for (let i = 0; i < select.options.length; i++) {
              // Check if Alt Text matches the option text exactly
              if (select.options[i].text.trim() === altText) {
                if (select.selectedIndex !== i) {
                  select.selectedIndex = i;
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }
          });
        }
      };

      // 1. Watch for class changes on thumbnails (for swipes/arrows)
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('is-active')) {
              syncVariant(target);
            }
          }
        });
      });

      // 2. Start observing all thumbnails
      const thumbs = document.querySelectorAll('.product__thumb');
      thumbs.forEach(thumb => {
        observer.observe(thumb, { attributes: true });
      });

      // 3. Fallback: Keep the click listener for instant response
      thumbContainer.addEventListener('click', (e) => {
        const clickedThumb = e.target.closest('.product__thumb');
        if (clickedThumb) syncVariant(clickedThumb);
      });
    };

    // Initialize on load
    if (document.readyState === 'complete') {
      initVariantSync();
    } else {
      window.addEventListener('load', initVariantSync);
    }
  })();
  // front-end-hydration-builder end

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
